import React from "react";
import "./App.css"; // Import the CSS file for styling

function ConsumerProtectionLaw(){

        return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Consumer Protection Law , Page Under Construction</h2>



        </div>;


}




export default ConsumerProtectionLaw;




